
export const COLORS = ['blue', 'green', 'red', 'yellow'];

//export const COLORS = ['blue', 'green', 'red', 'yellow', 'white', 'orange', 'pink'];